import { Component } from '@angular/core';
import { IonicPage, ToastController, PopoverController, Popover, ActionSheetController, LoadingController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { Alineados } from '../../models/designaciones';
import { PaginaBasica } from '../../models/PaginaBase';
import { Proxy } from '../../services/proxy/proxy.service';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';

export interface iQuinteto {
  alineado: Alineados,
  enQuinteto: boolean
}

@IonicPage()
@Component({
  selector: 'page-quinteto',
  templateUrl: 'quinteto.html',
})
export class QuintetoPage extends PaginaBasica {

  //#region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licenciasLocal: Proxy.ListaPrPersonaAlineable;
  public licenciasVisitante: Proxy.ListaPrPersonaAlineable;
  public participantesLocal: Proxy.ListaPrParticipacion;
  public participantesVisitante: Proxy.ListaPrParticipacion;
  public datosFutbolSala: Proxy.PrFutbolSala;
  //#endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: QUINTETO ---');

    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.MostrarOcultarCarga(false, "cargando quintetos");

    this.licenciasLocal = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idLocal);
    this.participantesLocal = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idLocal);
    this.licenciasVisitante = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idVisitante);
    this.participantesVisitante = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idVisitante);
    this.datosFutbolSala = new Proxy.PrFutbolSala(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);

    this.participantesLocal.CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licenciasLocal.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        return this.participantesVisitante.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licenciasVisitante.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        return this.datosFutbolSala.Cargar();
      })
      .then((resultado: Proxy.PrFutbolSala) => {
        this.datosFutbolSala = resultado;
        this.MostrarOcultarCarga();
      })
      .catch(error => this.Error(error, "ERROR al obtener los alineados del equipo actual"));
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event
    });
  }

  //#endregion

}



// WEBPACK FOOTER //
// ./src/pages/quinteto/quinteto.ts